import * as React from "react";
import { LoadingDotWrapper, LoadingDot } from "./styles";

interface LoadingProps {
	style?: React.CSSProperties;
}

export function Loading({ style = {} }: LoadingProps) {
	return (
		<LoadingDotWrapper style={style}>
			<LoadingDot>
				<div className={"loaderdot"} />
				<div className={"loaderdot"} />
				<div className={"loaderdot"} />
				<div className={"loaderdot"} />
				<div className={"loaderText"} />
			</LoadingDot>
		</LoadingDotWrapper>
	);
}

export default Loading;
